module.exports = __webpack_public_path__ + "fonts/OpenSans-Semibold.33f225b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/OpenSans-Semibold.ttf
// module id = ./src/assets/fonts/OpenSans-Semibold.ttf
// module chunks = 34